<div *ngIf="isShown">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title m-auto">
          {{'Cierre de gasto común en progreso' | translate}}
        </h3>
      </div>
      <div class="modal-body">
        <div class="row h-100 justify-content-center align-items-center px-3 text-center">
          {{'El cierre de Gasto Común se inició correctamente. Este proceso podría tomar algunos minutos, habilitaremos el módulo cuando finalice.' | translate}}
        </div>
        <br>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isShown">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/modal-lock/modal-lock.component.html